import type { EnvironmentConfig } from './environment.model';
import { HOME_LOCATOR_BASE_URL_STG } from './environment.constants';

const sharedOktaConfig = {
  redirectUri: '/login/callback',
  postLogoutRedirectUri: 'https://www.purolator.com',
  scopes: ['openid', 'profile', 'email'],
  pkce: true,
  audience: 'APP://VISION',
};

export const environment: EnvironmentConfig = {
  production: false,
  apiBaseUrl: '/api',
  /** Local development convenience only — must stay false in deployed builds. */
  authBypass: false,
  standardAccountNumber: 'VISA',
  okta: {
    issuer: 'https://nonprod-commonprofile.oauth.purolator.com/oauth2/ausj0r28qrsdN1TWL1d6',
    clientId: '0oa114u42l93uX1cl1d8',
    ...sharedOktaConfig,
  },
  chatbot: {
    configuratorUrl:
      'https://cdn.dev.k8s.ocp.ai/modules/omilia-webchat/staging/purolator/webchatconfigurator.esm.js',
  },
  gtm: {
    enabled: false,
    containerId: 'GTM-5HSQ6QPJ',
  },
  /** Home Locator base URL — `?postalcode=` prepopulation for View Map / Find other. */
  homeLocatorBaseUrl: HOME_LOCATOR_BASE_URL_STG,
  customerMaxTotalPieces: 5,
  declaredValueMaxExclusive: 5000,
  helpdeskPhone: '1-888-744-7123',
  monerisMode: 'qa',
  monerisCheckoutScriptUrl: 'https://gatewayt.moneris.com/chktv2/js/chkt_v3.00.js',
};
